// extracted by mini-css-extract-plugin
export default {"container":"style_container__NVOrm","icon":"style_icon__QSA3E"};